import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs';
import { FirebaseService } from './firebase.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private auth: AngularFireAuth,
    private afService: FirebaseService,
    private router: Router,
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.afService.isLoggedIn) {
      return true
    }
    else {
      return new Promise((resolve, reject) => {
        let sub = this.auth.authState.subscribe((auth: any) => {
          sub.unsubscribe()
          if (auth) {
            return resolve(true)
          }
          else {
            this.router.navigate(['login'])
            return resolve(false)
          }
        },
          (e) => reject(e)
        )
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/auth.guard.ts